import { Head } from '@inertiajs/react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import type { AdminEventsIndex } from '@/types';
import { CreateEventDialog } from './components/CreateEventDialog';
import { EventsTable } from './components/EventsTable';

export default function Index({ events, title }: AdminEventsIndex) {
  return (
    <>
      <Head title={title} />
      <div className="container mx-auto space-y-6 py-8">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="font-bold text-3xl tracking-tight">Events</h1>
            <p className="text-muted-foreground">
              Manage hackathon events and their schedules
            </p>
          </div>
          <CreateEventDialog />
        </div>

        <Card>
          <CardHeader>
            <CardTitle>All Events ({events.length})</CardTitle>
          </CardHeader>
          <CardContent className="p-0">
            <EventsTable events={events} />
          </CardContent>
        </Card>
      </div>
    </>
  );
}
